import {ReactNode} from 'react';
import ShowPageError from './ShowPageError';
import Spinner from './Spinner';
import {useCan, UseCanProps} from '@refinedev/core';

const StateBoundary = ({
  error,
  isLoading,
  children,
  // authorizationCheck,
}: {
  error?: any;
  isLoading?: boolean;
  children?: ReactNode;
  // authorizationCheck?: UseCanProps;
}) => {
  // const { data } = useCan(authorizationCheck ?? { resource: '', action: 'list' });

  // if (authorizationCheck && data?.can === false) {
  //   return <ShowPageError error={{ message: 'You are not authorized to access this resource' }} />;
  // }
  
  if (error) return <ShowPageError error={error} />;

  if (isLoading) {
    return <Spinner />;
  }

  return children;
};

export default StateBoundary;
